import React, { useState, useEffect } from 'react';
import jsyaml from 'js-yaml';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function YamlToJson() {
  const [yaml, setYaml] = useState('- id: 1\n  name: Item A\n- id: 2\n  name: Item B');
  const [json, setJson] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!yaml.trim()) {
      setJson('');
      return;
    }

    try {
      const doc = jsyaml.load(yaml);
      setJson(JSON.stringify(doc, null, 2));
    } catch (e) {
      setError(e.message);
      setJson('');
    }
  };

  const handleClear = () => {
    setYaml('');
    setJson('');
    setError('');
  };

  // Auto-convert sample data on load
  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="YAML to JSON Converter | Free Online Tool | UmbrellaCo"
        description="Instantly convert YAML configurations and files to valid JSON. Free online tool supporting strict YAML syntax validation."
        keywords="yaml to json, convert yaml to json, yaml to json converter online, parse yaml, online json tools"
        url="/json-tools/yaml-converter"
        jsonLd={createSoftwareAppSchema(
          'YAML to JSON Converter',
          'Instantly convert YAML configurations and files to valid JSON.',
          'https://umbrellaco.in/json-tools/yaml-converter',
          ['YAML Parsing', 'JSON Formatting', 'Syntax Validation']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
        title="YAML to JSON Converter"
        description="Translate strictly formatted YAML configurations into valid JSON objects."
        leftTitle="YAML"
        rightTitle="JSON"
        leftLanguage="yaml"
        rightLanguage="json"
        leftValue={yaml}
        setLeftValue={setYaml}
        rightValue={json}
        onConvert={handleConvert}
        onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default YamlToJson;